import React from 'react';
import {
  ChartBarIcon,
  CogIcon,
  InformationCircleIcon,
} from '@heroicons/react/outline'


  type Props = {
    setIsInfoModalOpen: (value: boolean) => void
    setIsStatsModalOpen: (value: boolean) => void
    setIsSettingsModalOpen: (value: boolean) => void
  }
  
  export const Navbar = ({
    setIsInfoModalOpen,
    setIsStatsModalOpen,
    setIsSettingsModalOpen,
  }: Props) => {
    return (
      <div className="navbar">
        <div className="navbar-center">

          <div className="left-icons">
            <InformationCircleIcon
              stroke="currentColor"
              className="h-6 w-6 stroke-white grow" viewBox="0 0 24 24" strokeWidth="2"
              onClick={() => setIsInfoModalOpen(true)}
            />
          </div>

          <div className='content_center'>
          <p className="text-center text-xl font-bold">Globle</p>
          </div>

          <div className="right-icons">
            <ChartBarIcon 
              stroke="currentColor"
              className="mr h-6 w-6 stroke-white grow" viewBox="0 0 24 24" strokeWidth="2"
              onClick={() => setIsStatsModalOpen(true)}
            />
            <CogIcon
              stroke="currentColor"
              className="h-6 w-6 stroke-white grow" viewBox="0 0 24 24" strokeWidth="2"
              onClick={() => setIsSettingsModalOpen(true)}
            />
          </div>

        </div>
        <hr></hr>
      </div>
    )
  }